import { createFileRoute, Navigate } from "@tanstack/react-router";

const Route = createFileRoute("/_authorized/subscription/")({
  component: () => <Navigate to="/subscription/overview" />,
});

export { Route };
